module.exports = {
      id: "thump-usage",
      viewBox: "0 0 58 75",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#thump",
      toString: function () {
        return this.url;
      }
    }